import React from 'react';
import { SelectMenu } from '@scale/scaleui';
import { enumValues } from '@scale/shared/utils';
import { ColorVariant } from '@scale/shared/taskTemplate/types';
import BuilderHint from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderHint';

interface ColorVariantBuilderProps {
  name: string;
  existingValue?: string;
  updateProperty: (arg: string) => void;
  required?: boolean;
  hint?: string;
}

const ColorVariantBuilder = ({
  existingValue,
  updateProperty,
  name,
  required,
  hint,
}: ColorVariantBuilderProps) => {
  return (
    <div>
      <label className="block text-sm font-medium leading-6 text-neutral-700">
        {name}
        {required && <span className="text-danger-400">*</span>}
      </label>
      <div className="flex flex-row">
        <SelectMenu
          className="min-w-[135px]"
          options={enumValues(ColorVariant).map(s => ({
            id: s,
            name: s,
          }))}
          selectedOptionId={existingValue as string}
          setSelected={updateProperty}
        />
        {hint && <BuilderHint name={name} hint={hint} />}
      </div>
    </div>
  );
};

export default ColorVariantBuilder;
